import { useMemo } from 'react';

function seededRandom(seed: number): number {
  const x = Math.sin(seed + 1) * 10000;
  return x - Math.floor(x);
}

// Bright white starfield — reads crisply over the vivid saturated hero grounds.
const STAR_COLORS = [
  'rgba(255,255,255,0.9)',
  'rgba(255,255,255,0.7)',
  'rgba(255,255,255,0.5)',
  'rgba(224,242,254,0.8)',
];

function generateShadows(count: number, offset: number): string {
  const shadows: string[] = [];
  for (let i = 0; i < count; i++) {
    const x = Math.floor(seededRandom(offset + i * 2) * 2000);
    const y = Math.floor(seededRandom(offset + i * 2 + 1) * 2000);
    const color = STAR_COLORS[Math.floor(seededRandom(offset + i * 3) * STAR_COLORS.length) % STAR_COLORS.length];
    shadows.push(`${x}px ${y}px ${color}`);
  }
  return shadows.join(', ');
}

/**
 * Three-layer parallax starfield.
 * Styles (layout + drift animation) live in ticca-animations.scss.
 * This component injects only the randomised box-shadow arrays.
 *
 * Wrap parent in `relative overflow-hidden`.
 */
export function StarsBackground() {
  const s1 = useMemo(() => generateShadows(700, 0),   []);
  const s2 = useMemo(() => generateShadows(200, 5000), []);
  const s3 = useMemo(() => generateShadows(100, 9000), []);

  return (
    <>
      <style>{`
        .ticca-s1 { box-shadow: ${s1}; }
        .ticca-s1::after { box-shadow: ${s1}; }
        .ticca-s2 { box-shadow: ${s2}; }
        .ticca-s2::after { box-shadow: ${s2}; }
        .ticca-s3 { box-shadow: ${s3}; }
        .ticca-s3::after { box-shadow: ${s3}; }
      `}</style>
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 overflow-hidden"
      >
        <div className="ticca-s1" />
        <div className="ticca-s2" />
        <div className="ticca-s3" />
      </div>
    </>
  );
}
